var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdjIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-40.9%",
    y: "-40.9%",
    width: "181.8%",
    height: "181.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "05-Jobs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.08---Customer---Contracts",
    transform: "translate(-871.000000, -408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(877.000000, 414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.87872954,17.6398865 C9.56294849,18.2133142 8.97085902,18.0904368 9.08927692,17.3531727 C9.36558534,15.6738488 9.7508144,13.7773411 10.0366201,12.1513646 C9.24310393,12.1513646 8.33929692,12.1513646 7.5498443,12.1513646 C6.99722746,12.1513646 6.87880956,11.8646507 7.11564535,11.4141004 C8.45771482,9.03847152 9.86065433,6.70687912 11.1237785,4.33125021 C11.3674074,3.84434908 12.0056036,3.89113698 11.8918337,4.4920093 C11.6155253,6.08941494 11.2385293,8.13105561 10.9796623,9.6528583 C11.7688271,9.6528583 12.6418137,9.6528583 13.470739,9.6528583 C13.9838832,9.6528583 14.1417737,9.93957214 13.8654653,10.4310816 C12.5628685,12.8067105 11.1418537,15.2232985 9.87872954,17.6398865 Z",
    id: "Path-Copy",
    fill: "#292929",
    transform: "translate(10.500000, 11.000000) rotate(-55.000000) translate(-10.500000, -11.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdjIcon);
export default __webpack_public_path__ + "static/media/ODJ_Icon.28b9c4fb0a1e1a99bd26684a69ca8bb9.svg";
export { ForwardRef as ReactComponent };